<template>
  <div :class="positionRight ? 'chart-time-select1' : 'chart-time-select'">
    <el-date-picker
      v-if="chartTimeSelectRadio === 'DAY'"
      v-model="timeValue"
      style="width: 280px;margin-right: 16px"
      :clearable="false"
      size="mini"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      :picker-options="pickerOptions"
    ></el-date-picker>
    <el-date-picker
      v-if="chartTimeSelectRadio === 'MONTH'"
      v-model="timeValue"
      style="width: 280px;margin-right: 16px"
      :clearable="false"
      size="mini"
      type="monthrange"
      range-separator="至"
      start-placeholder="开始月份"
      end-placeholder="结束月份"
      value-format="yyyy-MM"
    ></el-date-picker>
    <el-radio-group v-model="chartTimeSelectRadio" size="mini">
      <el-radio-button label="DAY">按日</el-radio-button>
      <el-radio-button label="MONTH">按月</el-radio-button>
      <el-radio-button label="YEAR">按年</el-radio-button>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  name: "ChartTimeSelect",
  props: {
    // chartTimeSelectRadio: {
    //   type: String,
    //   default() {
    //     return 'DAY'
    //   }
    // },
    positionRight: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    var vue = this;
    return {
      chartTimeSelectRadio: "DAY",
      timeValue: [],
      isRestart: false,
      pickerMinDate: '',
      pickerOptions: {
        onPick: ({
          maxDate,
          minDate,
        }) => {
          this.isRestart = false;
          this.pickerMinDate = minDate.getTime();
          if (maxDate) {
            this.pickerMinDate = "";
          }
        },

        disabledDate: (time) => {
          if (this.pickerMinDate !== "") {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.pickerMinDate - one;
            const maxTime = this.pickerMinDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        },
      },
    };
  },
  created() {
    this.getCreateTime();
  },
  methods: {
    getCreateTime() {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let lastDate = new Date(nowDate - 1000 * 60 * 60 * 24 * 30);
      let lastYear = lastDate.getFullYear();
      let lastMonth =
        lastDate.getMonth() + 1 < 10
          ? "0" + (lastDate.getMonth() + 1)
          : lastDate.getMonth() + 1;
      let lastDay =
        lastDate.getDate() < 10 ? "0" + lastDate.getDate() : lastDate.getDate();
      let timeValue = [
        `${lastYear}-${lastMonth}-${lastDay}`,
        `${year}-${month}-${date}`
      ];
      this.timeValue = timeValue;
    },
    getMonth() {
      // 获取当前日期
      var currentDate = new Date();
      // 获取当前年份
      var currentYear = currentDate.getFullYear();
      // 获取当前月份（注意：月份是从0开始的，所以要加1）
      var currentMonth = currentDate.getMonth() + 1;
      // 计算比当前日期早11个月的年份和月份
      var earlierYear = currentMonth > 11 ? currentYear : currentYear - 1;
      var earlierMonth = currentMonth > 11 ? currentMonth - 11 : currentMonth + 1;
      // 调整月份，如果计算结果为负数，则需要向前借一年
      if (earlierMonth <= 0) {
        earlierMonth = 12 + earlierMonth;
        earlierYear -= 1;
      }
      // console.log("当前年份：" + currentYear);
      // console.log("当前月份：" + currentMonth);
      // console.log("比当前日期早11个月的年份：" + earlierYear);
      // console.log("比当前日期早11个月的月份：" + earlierMonth);
      this.timeValue[1] = `${currentYear}-${currentMonth < 10 ? "0" + currentMonth : currentMonth}`;
      this.timeValue[0] = `${earlierYear}-${earlierMonth < 10 ? "0" + earlierMonth : earlierMonth}`;
    },
    getTableData() {
      let startTime = "",
        endTime = "";
      if (this.timeValue) {
        startTime = this.timeValue[0];
        endTime = this.timeValue[1];
      }
      this.$emit("getData", this.chartTimeSelectRadio, startTime, endTime);
    },
  },
  watch: {
    chartTimeSelectRadio(val) {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      if (this.chartTimeSelectRadio === "DAY") {
        this.getCreateTime();
      } else if (this.chartTimeSelectRadio === "MONTH") {
        this.getMonth();
      } else {
        this.timeValue[0] = "";
        this.timeValue[1] = "";
      }
      this.getTableData();
    },
    timeValue(val) {
      this.getTableData();
    }
  }
};
</script>

<style scoped lang="less">
.chart-time-select {
  width: 520px;
  position: absolute;
  top: 15px;
  right: 0;
  left: 0;
  margin: 0 auto;
  z-index: 1001;
  display: flex;
  justify-content: left;
  align-items: center;
}

.chart-time-select1 {
  width: 520px;
  position: absolute;
  top: 10px;
  right: 0.3rem;
  z-index: 1001;
  text-align: right;
}

/deep/ .el-date-editor .el-range-separator {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Echarts/ChartTimeSelect/ChartTimeSelect.vue